import { render } from "./LoginPage.vue?vue&type=template&id=62a81b61&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=62a81b61&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a81b61"]])

export default __exports__